import { usePublicBoundlessConfigRetrieveSuspense } from "@boundless/bl-api-client/public/services"

import { LinkToHomepage } from "@/components/error/LinkToHomepage"
import { Button } from "@/components/ui/button"
import BoundlessLogo from "@/svg/boundless/logo.svg?react"
import ErrorIllustration from "@/svg/illustrations/error.svg?react"

/**
 * @summary Displays a "missing permissions" page to the user.
 */
export function NoPermissionComponent() {
  const { data: boundlessConfig } = usePublicBoundlessConfigRetrieveSuspense()

  return (
    <div className="flex h-full flex-col items-center justify-around space-y-8 p-4">
      <BoundlessLogo className="h-12 w-auto" />
      <ErrorIllustration className="w-full max-w-md" />
      <div className="text-center">
        <h1 className="text-4xl font-extrabold">Access denied.</h1>

        <p className="mx-auto mt-4 max-w-md text-balance text-neutral-500">
          You don&apos;t have the necessary permissions. Please contact{" "}
          <a
            href={`mailto:${boundlessConfig.supportEmail}`}
            className="hover:underline"
          >
            {boundlessConfig.supportEmail}
          </a>
          .
        </p>

        <LinkToHomepage>
          <Button className="mt-6">Back to Homepage</Button>
        </LinkToHomepage>
      </div>
    </div>
  )
}
